import { apiSlice } from '../../app/api/apiSlice'

export const actionsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    listActions: builder.query ({
      query: () => `v4/actions/`,
      keepUnusedDataFor: 1
    }),
    runAction: builder.mutation ({
      query: ({action, data}) => ({
        url: `v4/action/${action}`,
        method: 'POST',
        body: data
      })
    })
  }),
})

export const {
    useListActionsQuery,
    useRunActionMutation
} = actionsApi
